import { useMemo } from 'react';
import { getIn } from 'formik';
import { policyType } from '@ourbranch/lookups';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';

import { useStore } from 'core/store/store.mobx';
import { useRouteHelper } from 'core/hooks/use-route-helper';

const POLICY_TYPE_STATE_PATHS = {
  [policyType.Home]: 'home.homeLocation.state',
  [policyType.Condo]: 'condo.condoLocation.state',
  [policyType.Renters]: 'rentersCoverage.rentersLocation.state',
  [policyType.Auto]: 'correctedAddress.state'
};

export const useCurrentState = (formikValues, options = {}) => {
  const { policyType: coveragePolicyType, locationIndex = 0 } = options;
  const store = useStore();
  if (!store && !formikValues) {
    throw new Error('This hook has to be called inside policyStore or offer formik context');
  }
  const { inPolicyRoute, inCustomerRoute } = useRouteHelper();
  const policy = store.account.policies?.policy?.policy;
  const policies = store.account.policies.list;
  const offer = store.offer;

  return useMemo(() => {
    if (inPolicyRoute && policy) {
      return policy.state;
    }

    if (inCustomerRoute && policies?.length) {
      return policies[0].state;
    }

    if (coveragePolicyType) {
      const path = isFarmBasedPolicyType(coveragePolicyType)
        ? `farmLocations[${locationIndex}].address.state`
        : POLICY_TYPE_STATE_PATHS[coveragePolicyType];

      if (path) {
        const fromForm = getIn(formikValues, path);
        if (fromForm) {
          return fromForm;
        }
        const fromStore = getIn(offer?.offer?.quote, path);
        if (fromStore) {
          return fromStore;
        }
      }
    }

    return offer.state || getIn(formikValues, 'correctedAddress.state') || getIn(formikValues, 'address.state');
  }, [policy, formikValues, offer, policies, inPolicyRoute, inCustomerRoute, coveragePolicyType, locationIndex]);
};
